export let httpClient = null

export function initHttpClient(client) {
  httpClient = client
}
